import {Select} from '@wandb/weave/components/Form/Select';
import React from 'react';
import {type SingleValue} from 'react-select';

import {type FanOutVariable} from '../../../../PanelMediaBrowser/common';
import {useMediaCompareSettingsDisplay} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';
import {setFanOutVariable} from './util';

type FanOutOption = {
  value: 'none' | FanOutVariable;
  label: string;
};

export const FanOut = () => {
  const {updateConfig, settingsLevel, panelRef} = useMediaSettingsContext();
  const compareSettings = useMediaCompareSettingsDisplay(
    settingsLevel,
    panelRef
  );

  const isControlLinked = (control: FanOutVariable) => {
    return compareSettings?.tileControls?.[control] === 'linked';
  };

  const isRunShared = isControlLinked('run');
  const isStepShared = isControlLinked('step');
  const isIndexShared = isControlLinked('index');
  const options: FanOutOption[] = [{value: 'none', label: 'None'}];
  if (isStepShared) {
    options.push({value: 'step', label: 'Step'});
  }
  if (isIndexShared) {
    options.push({value: 'index', label: 'Index'});
  }
  if (isRunShared) {
    options.push({value: 'run', label: 'Run'});
  }
  const currentValue = compareSettings?.fanOutVariable || 'none';
  let selectedOption: FanOutOption | undefined = options.find(
    option => option.value === currentValue
  );

  if (selectedOption === undefined) {
    setFanOutVariable(compareSettings, updateConfig, undefined);
    selectedOption = options[0]; // none
  }

  const onChangeDropdown = (option: SingleValue<FanOutOption>) => {
    if (option) {
      setFanOutVariable(
        compareSettings,
        updateConfig,
        option.value === 'none' ? undefined : option.value
      );
    }
  };

  const disabled = options.length === 1;

  return (
    <div className="flex flex-col">
      <SettingTitle title="Fan out" />
      <Select<FanOutOption>
        isDisabled={disabled}
        className="w-full"
        aria-label="Fan out"
        options={options}
        value={selectedOption}
        onChange={onChangeDropdown}
        data-test="fan-out-select"
      />
    </div>
  );
};
